import gql from 'graphql-tag'

export const pinRecoveryLookup = gql`
  query pinRecoveryLookup($installationId: ID!, $search: String!) {
    pinRecoveryLookup(installationId: $installationId, search: $search) {
      id
      kind
      status
      pin
      validFrom
      validTo
      plate
      enteredAt
      bookingId
      bookingLabel
      bookingStatus
      guestName
      guestEmail
      lastError
      canRevoke
      canRetry
      canResend
    }
  }
`

export const revokePinCredential = gql`
  mutation revokePinCredential($credentialId: ID!, $reason: String!) {
    revokePinCredential(credentialId: $credentialId, reason: $reason) {
      outcome
      message
      status
    }
  }
`

export const retryPinProvisioning = gql`
  mutation retryPinProvisioning($credentialId: ID!, $reason: String) {
    retryPinProvisioning(credentialId: $credentialId, reason: $reason) {
      outcome
      message
      status
    }
  }
`

export const resendPinCredential = gql`
  mutation resendPinCredential($credentialId: ID!, $reason: String) {
    resendPinCredential(credentialId: $credentialId, reason: $reason) {
      outcome
      message
      status
    }
  }
`
